import { useState } from 'react';
import { openBillingPortal } from '../utils/billing';

/** Button that sends an owner/admin to the Stripe Customer Portal. */
export default function BillingButton({ orgId, label = 'Billing', className = '' }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const go = async () => {
    setBusy(true);
    setError('');
    try {
      await openBillingPortal(orgId);
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };
  return (
    <span className="inline-flex flex-col items-start gap-1">
      <button type="button" onClick={go} disabled={busy}
        className={`inline-flex items-center justify-center h-11 px-4 rounded-xl border border-line-strong bg-white text-ink font-semibold hover:bg-surface transition disabled:opacity-60 ${className}`}>
        {busy ? 'Opening billing...' : label}
      </button>
      {error && <span role="alert" className="text-sm text-coral-ink max-w-xs">{error}</span>}
    </span>
  );
}
